<template>
  <div class="imageplacement">
    <mad-form>
      <mad-form-item label="Top">
        <mad-input v-model="form.top" class="input" @input="onInput" />
      </mad-form-item>
      <mad-form-item label="Right">
        <mad-input v-model="form.right" class="input" @input="onInput" />
      </mad-form-item>
      <mad-form-item label="Width">
        <mad-input v-model="form.width" class="input" @input="onInput" />
      </mad-form-item>
    </mad-form>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: String, default: null },
  },

  data: () => ({
    form: {
      position: '',
      top: '',
      right: '',
      width: '',
    },
  }),

  watch: {
    value(to, from) {
      this.fetchDimensions()
    },
  },

  created() {
    this.fetchDimensions()
  },

  methods: {
    fetchDimensions() {
      let inputs = this.value.split(';')
      let dimensions = {}

      for (const input of inputs) {
        const [key, value] = input.split(':')
        dimensions[key] = value.replace('px', '')
      }
      this.form = dimensions
    },
    onInput() {
      this.$emit('input', `position:absolute;top:${this.form.top}px;right:${this.form.right}px;width:${this.form.width}px`)
    },
  },
}
</script>

<style lang="scss">
.input {
  width: 100px;
}

</style>
